<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 项目基本资料</div>
    <el-form-item label="申报单位">
      <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目负责人">
          <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系方式">
          <el-input size="small" :disabled="true" v-model="userData.mobile"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <!-- <el-form-item label="审批类型">
      <el-input size="small" v-model="form.type"></el-input>
    </el-form-item> -->

    <div class="clear">
      <el-col :span="10">
        <el-form-item label="审批类型">
          <el-input size="small" v-model="form.type" placeholder="请输入审批类型"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="13">
        <div class="tip" style="padding-bottom:0;padding-top:6px;">请输入审批所属类型，如请示、报备等（2-6个字为佳）。</div>
      </el-col>
    </div>

    <el-form-item label="标题">
      <el-input size="small" placeholder="请输入审批的标题" v-model="form.title"></el-input>
    </el-form-item>
    <el-form-item label="审批内容">
      <el-input type="textarea" placeholder="审批的情况介绍（情况、目的、要求、时间及意义）" :autosize="{ minRows: 5, maxRows: 8}"
        size="small" v-model="form.content"></el-input>
    </el-form-item>

  </section>
</template>

<script>
  export default {
    props: ['formByFather', 'userData', 'teamArr', 'projectArr'],
    data() {
      return {
        form: {},
      }
    },
    mounted() {
      this.form = this.formByFather

      this.form.depId = this.userData.secDepIds.split(",")[0]
      this.form.leaderId = this.userData.id
    },
    methods: {
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createCommonApproval.vue